/**
 * Progress wrapper — enforces design system defaults for Ant Design Progress.
 *
 * When `status="active"` and no explicit `strokeColor` is provided,
 * defaults to the accent-500 token colour.
 *
 * All other Ant Design Progress props are passed through unchanged.
 */

import { Progress as AntProgress } from 'antd';
import type { ComponentProps } from 'react';

type ProgressProps = ComponentProps<typeof AntProgress>;

function Progress(props: ProgressProps) {
    const { status, strokeColor, ...rest } = props;

    const resolvedStrokeColor =
        status === 'active' && strokeColor === undefined ? 'var(--color-accent-500)' : strokeColor;

    return <AntProgress status={status} strokeColor={resolvedStrokeColor} {...rest} />;
}

export type { ProgressProps };
export { Progress };
